import {toast} from "react-toastify";
import AppConstants from "#/src/utils/app-constants";
import {composeHeaders} from "#/src/utils/api-request-utils";
import {usePageContext} from "vike-react/usePageContext";
import {AppPageContext} from "#/src/definitions/AppDefinitions";
import {navigate} from "vike/client/router";
import React, {useState} from "react";
import {BrandLogo} from "#/src/components/BrandLogo";
import {TwoFactorCodeReturn, TwoFactorModal, TwoFactorStatus} from "#/src/components/TwoFactorModal";
import {doIntercept2FA, is2FAInvalid} from "#/src/utils/2fa-response-interceptor";

export function Content() {
  const pageContext = usePageContext() as AppPageContext;
  const [isTwoFactor, setTwoFactor] = useState(false);

  async function onForget(code: TwoFactorCodeReturn | null) {
    const login = (document.getElementById("login") as HTMLInputElement).value;
    if(login == null) {
      toast("Musisz podać adres email");
      return;
    }
    const headers = composeHeaders(pageContext);
    if(code) {
      headers["X-2FA-Code"] = code.code;
      headers["X-2FA-Type"] = code.type;
    }
    const response = await fetch(`${AppConstants.GENERIC_API_ROUTE}/v1/service/password-reset`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({login})
    });
    if(response.ok) {
      if (code && code?.type == "BACKUP_CODES") {
        toast("Wykorzystałeś kod zapasowy, został on teraz unieważniony.");
        setTimeout(() => {
          setTwoFactor(false);
          navigate(`/reset-instruction/${login}`);
        }, 1750);
      } else {
        setTwoFactor(false);
        await navigate(`/reset-instruction/${login}`);
      }
    } else {
      const errorResponse = await response.json() as any;
      if (doIntercept2FA(errorResponse, () => setTwoFactor(true))) {
        return;
      }
      if(is2FAInvalid(errorResponse)) {
        return TwoFactorStatus.INVALID;
      }
      if(errorResponse && errorResponse.errors) {
        errorResponse.errors.forEach(err => toast(err));
      }
    }
  }

  function onEnterCheck(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") {
      document.getElementById("forgetButton").click();
    }
  }

  return <section className="register-wrapper pt-4">
    <TwoFactorModal id={"passwdReset2fa"} isOpen={isTwoFactor} onHide={() => setTwoFactor(false)} onCodeProvide={onForget}/>
    <div className="container p-0 h-100">
      <div className="row g-0 h-100">
        <div className="col-xl-12">
          <div className="login-brand text-center justify-content-center">
            <a href={"/"}><BrandLogo/></a>
          </div>
        </div>
        <div className="col-xl-5 mx-auto my-auto">
          <div className="panel mt-4">
            <div className="panel-title">
              <h2 className="basic-headline mb-2">
                Przypomnij hasło
              </h2>
              <p>Wpisz adres e-mail, którego używasz w witrynie jarock.pl</p>
            </div>
            <div className="login-form mt-4">
              <div className="mb-3">
                <label htmlFor="login" className="form-label">Adres e-mail</label>
                <input type="email" className="form-control" id="login" placeholder="Wpisz swój e-mail" onKeyDown={onEnterCheck}/>
              </div>
            </div>
            <button id={"forgetButton"} className="btn btn-primary w-100 my-2" onClick={() => onForget(null)}>Wyślij hasło</button>
            <div className="sign-up">
              <span>Wróć do <a href={"/login"}>Zaloguj się</a></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}